import styled from "styled-components";

import { colors } from "shared/ui/tokens";

export const RowActions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 4px;
`;

// Код промокода — то, что заведение диктует гостю: моноширинный, чтобы не путались O и 0.
export const Code = styled.span`
    font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
    font-size: 14px;
    letter-spacing: 0.04em;
`;

export const Expired = styled.span`
    color: ${colors.textSecondary};
`;
